import { Routes, Route } from "react-router-dom";
import Sad from "../pages/Sad";
import Sadformulario from "../pages/Sad/formulario";
import Home from "../pages/Home";
import { InclusoesSad } from "../pages/InclusaoSad";
import Record from "../pages/Record";
import RecordEdite from "../pages/RecordEdite";
import RecordAval from "../pages/RecordAval";
import RecuperarSad from "../pages/RecuperaExtraSad";
import PacientesHomeCareEInterior from "../pages/PacientesHomeCareEInterior";
import RecordVoice from "../pages/RecordVoice";
import Record2 from "../pages/Record2";
import InstrumentoAvalNivelAssistenciaDomiciliar from "../pages/InstrumentoAvalNivelAssistenciaDomiciliar";
import Login from "../pages/Login";
import PrivateRoute from "../components/PrivateRoute"; // Importe o componente de rota privada
import NotFound from "../components/NotFound"; // Importe o componente de rota privada
import Prontuarios from "../pages/Prontuarios/Prontuarios";
import Sisclinic from "../components/Medico/index";
export const Initial = () => {
  const isAuthenticated = !!localStorage.getItem("Frontend"); // Aqui você pode ajustar conforme sua lógica de autenticação

  return (
    <Routes>
      <Route path="/" element={<Login />} />       
      <Route path="/Home" element={<PrivateRoute isAuthenticated={isAuthenticated} element={<Home />} />} />
{/*       <Route path="/FichaDeEvolucao" element={<PrivateRoute isAuthenticated={isAuthenticated} element={<FichaDeEvolucao />} />} />
 */}      <Route path="/Sad" element={<PrivateRoute isAuthenticated={isAuthenticated} element={<Sad />} />} />
      <Route path="/Sad_Formulario" element={<PrivateRoute isAuthenticated={isAuthenticated} element={<Sadformulario />} />} />
      <Route path="/Recupera_Extra_Sad" element={<PrivateRoute isAuthenticated={isAuthenticated} element={<RecuperarSad />} />} />
      <Route path="/Inclusoes_Sad" element={<PrivateRoute isAuthenticated={isAuthenticated} element={<InclusoesSad />} />} />
      <Route path="/Record" element={<PrivateRoute isAuthenticated={isAuthenticated} element={<Record />} />} />
      <Route path="/RecordEdite" element={<PrivateRoute isAuthenticated={isAuthenticated} element={<RecordEdite />} />} />
      <Route path="/Record_Aval" element={<PrivateRoute isAuthenticated={isAuthenticated} element={<RecordAval />} />} />
      <Route path="/Record2" element={<PrivateRoute isAuthenticated={isAuthenticated} element={<Record2 />} />} />
      <Route path="/Record_Voice" element={<PrivateRoute isAuthenticated={isAuthenticated} element={<RecordVoice />} />} />
      <Route path="/Pacientes_HomeCare_E_Interior" element={<PrivateRoute isAuthenticated={isAuthenticated} element={<PacientesHomeCareEInterior />} />} />
      <Route path="/Instrumento_AvalNive_SAD" element={<PrivateRoute isAuthenticated={isAuthenticated} element={<InstrumentoAvalNivelAssistenciaDomiciliar />} />} />  
      <Route path="/Prontuarios" element={<PrivateRoute isAuthenticated={isAuthenticated} element={<Prontuarios />} />} />    
      <Route path="*" element={<NotFound/>} />   
      <Route path="/medico/Record" element={<PrivateRoute isAuthenticated={isAuthenticated} element={<Sisclinic />} />} />
    </Routes>
  );
};
